/**
 * Asset problem attachment configuration.
 */

export const attachmentSectionDefinitions = [
    {
        key: 'picture',
        label: 'Pictures (optional)',
        accept: '.jpg,.jpeg,.png,.gif,.webp',
        helper: 'JPG, PNG, GIF, or WEBP up to 200KB each.',
        uploadEnabled: true
    },
    {
        key: 'video',
        label: 'Videos (optional)',
        accept: '.mp4,.mov,.webm',
        helper: 'MP4, MOV, or WEBM.',
        uploadEnabled: true
    },
    {
        key: 'quote_document',
        label: 'Quote documents (optional)',
        accept: '.pdf,.docx,.xlsx',
        helper: 'PDF, DOCX, or XLSX quote files only.',
        uploadEnabled: true
    }
]

export function isAttachmentUploadEnabled (attachmentType) {
    const section = attachmentSectionDefinitions.find(def => def.key === attachmentType)
    return section ? section.uploadEnabled : false
}

export function shouldShowAttachmentSection (section, existingAttachments = []) {
    if (section.uploadEnabled) {
        return true
    }
    return (existingAttachments || []).some(attachment => attachment.attachmentType === section.key)
}

const PREVIEW_ATTACHMENT_TYPES = new Set(['picture', 'video'])

export function createPendingAttachmentItem (attachmentType, file) {
    return {
        file,
        previewUrl: PREVIEW_ATTACHMENT_TYPES.has(attachmentType)
            ? URL.createObjectURL(file)
            : null
    }
}

export function revokePendingAttachmentPreviews (pendingAttachments) {
    Object.values(pendingAttachments || {}).flat().forEach(item => {
        if (item?.previewUrl) {
            URL.revokeObjectURL(item.previewUrl)
        }
    })
}

export function pendingAttachmentFile (pendingItem) {
    return pendingItem?.file ?? pendingItem
}
